const defaultState = {
  customerLocations: null,
  error: null,
  fetching: false,
  fetched: false
};

const getCustomerWithLocationsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'CUSTOMER_LOCATION_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true
      };
    }
    case 'CUSTOMER_LOCATION_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, customerLocations: action.payload.data
      };
    }
    case 'CUSTOMER_LOCATION_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        customerLocations: null,
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getCustomerWithLocationsReducer;


// WEBPACK FOOTER //
// ./src/reducers/getCustomerWithLocations.js